import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import parseContent from '../editor/parseContent';
import Container from '../editor/container';
import Editor from '../editor';
import '../editor/styles.css';
import { Link } from 'react-router-dom';
import config from 'src/config';
import EditModal from './editModal';
import LinkItem from './linkItem';
import Tabs from './tabs';

const iframes = {
  chatsales: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  chrissales: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  wellhello: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  easysex: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  cupid: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  loc: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  imlive: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  cevip: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  sexplaycam: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  sandra_sales: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  hookupbay: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  dgold: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ],
  punk: [
    {
      name: '1',
      value:
        'https://www.hookupfriend.com/orangecams/index2.php?wid={wid}&subaffiliate={subaffiliate}&click_id={click_id}&agent={agent}&ip={ip}'
    }
  ]
};

class Component extends React.Component {
  initialState = {
    link_id: 0,
    link_name: '',
    link: '',
    hidden: false,
    wids: '',
    imagesCount: 0,
    editable: 0,
    file: null,
    image: null,
    orderid: 0,
    redirect_wids: '',
    redirect_to: 0,
    suboffer: '',
    tab: null,
    modalOpen: false,
    imagesModalOpen: false,
    images: {},
    copied: ''
  };

  state = this.initialState;
  fileInput = null;

  componentWillMount() {
    if (this.props.apiState.initial) {
      this.props.api('links/available').then((res) => {
        let offers = Object.keys(res) || [];
        let defaultTab = offers[0];
        // if (res.spice) defaultTab = 'spice';
        this.setState({ tab: defaultTab });
        this.initialState.tab = defaultTab;
      });
    }
    if (this.props.state.tab) {
      this.initialState.tab = this.props.state.tab;
      this.setState({ tab: this.props.state.tab });
    }
    window.iframeData = {
      wid: this.props.user.owner_wid ? this.props.user.owner_wid : this.props.user.aid,
      subaffiliate: this.props.user.owner_wid ? this.props.user.aid : '',
      click_id: 0,
      agent: '',
      ip: '127.0.0.1'
    };
  }

  componentDidMount() {
    if (parseInt(this.props.user.aid) == 5) {
      this.props.api('affLists/load');
    }
  }

  openTab = (tab, e) => {
    if (tab != this.state.tab) {
      console.log('openTab', tab);
      this.initialState.tab = tab;
      this.setState({ tab });
      this.props.setState({ tab });
    }
    e && e.preventDefault();
  };

  onSaveLink = (res, item, type) => {
    if (res && res.result) {
      if (this.inputFile) this.inputFile.value = null;
      this.setState(this.initialState);
      let items = this.props.items;
      items[type].map((_item, index) => {
        if (item.link_id == _item.link_id) {
          items[type][index] = {
            ...item
          };
        }
      });
      this.props.changeItems(items);
      this.setState({ d: Date.now() });
      // this.props.api('links/available');
    }
  };

  onRemoveLink = (res) => {
    if (res && res.result) {
      this.props.api('links/available');
      this.setState(this.initialState);
      if (this.inputFile) this.inputFile.value = null;
    }
  };

  handleInputChange = (event) => {
    const target = event.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    value = target.type === 'file' ? target.files[0] : value;
    this.setState({
      [target.name]: value
    });
  };

  uploadImage = (event, index) => {
    // let fd = new FormData()
    // fd.append("link_id",this.state.link_id)
    // fd.append("image_id",index)
    let data = {
      link_id: this.state.link_id || 0,
      image_id: index,
      '__files[]': event.target.files[0]
    };
    // for (var x = 0; x < event.target.files.length; x++) {
    //   fd.append("__files[]", event.target.files[x]);
    // }

    let images = this.state.images;
    images[index].progress = 1;
    images[index].error = '';
    this.setState({ images });
    // console.log("uploadImage",fd)
    this.props
      .api(
        'links/custom_image',
        data,
        true,
        (e, progress) => {
          images[index].progress = progress;
          this.setState({ images });
        },
        true
      )
      .then((res) => {
        console.log('links/custom_image res:', res);
        if (res && res.url) {
          let images = this.state.images;
          images[index].input.value = null;
          images[index].progress = 100;
        } else {
          images[index].error = (res && res.error && res.error.message) || 'error';
        }
        this.setState({ images });
      });
  };

  openModal = (e, Link, type) => {
    e.preventDefault();
    let images = {};
    for (var i = 1; i <= Link.images; i++) {
      images[i] = {
        progress: 0,
        error: ''
      };
    }
    this.setState({
      ...Link,
      images: images,
      imagesCount: Link.images,
      editorState: 'loading',
      contentObj: false,
      modalOpen: type,
      editLink: Link
    });
    if (type == 'editor') {
      this.props
        .api('links/custom_content', {
          linkId: Link.link_id
        })
        .then((res) => {
          if (!res || res.error || typeof res.content == 'undefined') {
            this.setState({
              editorState: 'error'
            });
          } else {
            this.setState({
              editorState: 'ready',
              contentId: res.id || 0,
              content: res.content,
              contentObj: parseContent(res.content),
              editorMode: 'edit'
            });
          }
        });
    }
  };

  getImageState = (i) => {
    let imgState = this.state.images[i];
    if (!imgState) return '';
    if (imgState.error) return imgState.error;
    if (imgState.progress == 100) {
      let imagePath =
        '/uploads/images/' + this.props.user.aid + '/link_' + this.state.link_id + '/img_';
      return <img class='link-custom-img' src={imagePath + i + '.jpg'} />;
    } else if (imgState.progress > 0) {
      return this.state.images[i].progress + '%';
    }
    return '';
  };

  handleChangeEditor = (e) => {
    const target = event.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    value = target.type === 'file' ? target.files[0] : value;
    this.setState({
      [target.name]: value
    });
    event.preventDefault && event.preventDefault();
  };

  saveEditor = (e) => {
    e.preventDefault();
    let params = {
      linkId: this.state.link_id,
      content: JSON.stringify(this.state.contentObj),
      contentId: this.state.contentId
    };
    if (this.state.id) params['id'] = this.state.id;
    this.setState({ editorState: 'saving' });
    this.props.api('links/custom_content_save', params).then((res) => {
      console.log('res', res);
      if (res && typeof res.result != 'undefined') {
        this.setState(this.initialState);
      } else {
        this.setState({ editorState: 'error' });
        // this.setState(this.initialState);
      }
    });
  };

  closeEditModal = (link) => {
    this.setState({ modalOpen: false, image: null });
  };

  onCopy = (copied) => {
    this.setState({ copied });
  };

  renderEditorModal() {
    if (this.state.modalOpen != 'editor') return;
    return (
      <div
        class={
          'modal fade black-overlay ' + (this.state.modalOpen == 'editor' ? 'show d-block' : '')
        }
      >
        <div class='modal-dialog modal-lg'>
          <div class='modal-content'>
            <div class='modal-header'>
              <h5 class='modal-title'>Edit landing</h5>
            </div>
            <div class='modal-body'>
              {this.state.contentObj && (
                <Editor
                  data={this.state.contentObj}
                  mode={this.state.editorMode}
                  iframes={iframes[this.state.tab]}
                  onChange={this.handleChangeEditor}
                />
              )}
            </div>
            <div class='modal-footer'>
              <button
                type='button'
                class='btn warning'
                onClick={(e) => this.setState({ modalOpen: false })}
              >
                Cancel
              </button>
              <button type='button' class='btn primary ml-2' onClick={this.saveEditor}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderImagesModal() {
    if (this.state.modalOpen != 'images') return;
    return (
      <div
        class={
          'modal fade black-overlay ' + (this.state.modalOpen == 'images' ? 'show d-block' : '')
        }
      >
        <div class='modal-dialog modal-lg'>
          <div class='modal-content'>
            <div class='modal-header'>
              <h5 class='modal-title'>Upload images</h5>
            </div>
            <div class='modal-body'>
              {[...Array(parseInt(this.state.imagesCount))].map((e, i) => (
                <div class='form-group row' key={i}>
                  <label class='col-sm-2 col-form-label'>Image {i + 1}</label>
                  <div class='col-sm-7'>
                    <input
                      type='file'
                      class='form-control'
                      name='__files[]'
                      onChange={(e) => this.uploadImage(e, i + 1)}
                      ref={(input) => {
                        this.state.images[i + 1].input = input;
                      }}
                    />
                  </div>
                  <div class='col-sm-3 overflow-auto'>{this.getImageState(i + 1)}</div>
                </div>
              ))}
            </div>
            <div class='modal-footer'>
              <button
                type='button'
                class='btn warning'
                onClick={(e) => this.setState({ modalOpen: false, image: null })}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let apiState = this.props.apiState;
    let allLinks = this.props.items;
    let user = this.props.user;
    let currentTab = this.state.tab;
    let links = (currentTab && allLinks && allLinks[currentTab]) || [];
    let userOffers = Object.keys(allLinks) || [];
    console.log('links redner', { currentTab });
    return (
      <div>
        {this.state.modalOpen == 'edit' && (
          <EditModal
            link={this.state}
            type={currentTab}
            handleInputChange={this.handleInputChange}
            onRemoveLink={this.onRemoveLink}
            onSaveLink={this.onSaveLink}
            inputRef={(input) => {
              this.fileInput = input;
            }}
            closeEditModal={this.closeEditModal}
          />
        )}
        {apiState.loading && <div>loading..</div>}
        <div>
          {!apiState.loading && (
            <Tabs openTab={this.openTab} userOffers={userOffers} currentTab={currentTab} />
          )}
          {currentTab && (
            <div class='tab-content'>
              <div class='tab-pane pt-3 active'>
                <div class='links-tab-description'>
                  {this.props.user.role_id >= 3 && (
                    <button
                      class='btn warning m-1'
                      onClick={(e) => this.openModal(e, this.initialState, 'edit')}
                    >
                      Add
                    </button>
                  )}
                  {user.owner_wid == 0 && (
                    <span class='pull-right links-sales-amount'>
                      $ {user[currentTab + '_earnings']} Pay per trial
                    </span>
                  )}
                  {user.owner_wid != 0 && (
                    <span class='pull-right links-sales-amount'>
                      $ {user['chatsales_earnings']} Pay per trial
                    </span>
                  )}
                  <br />
                </div>
                {this.renderImagesModal()}
                {this.renderEditorModal()}
                {links.map((link) => (
                  <LinkItem
                    key={link.link_id + '_' + link.link}
                    onCopy={this.onCopy}
                    copied={this.state.copied}
                    link={link}
                    url={link.link}
                    openModal={this.openModal}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

import api from 'src/actions/api';
import setState from 'src/actions/state';
import { connect } from 'react-redux';

export default connect(
  function (state) {
    return {
      apiState: state.api['links_available'] || state.api.initial,
      items: (state.api['links_available'] || state.api.initial).data || [],
      saveApiState: state.api['links_save'] || state.api.initial,
      removeApiState: state.api['links_remove'] || state.api.initial,
      state: state.state['links_available'] || state.state.initial,
      user: state.session.user
    };
  },
  {
    api,
    setState: setState('links_available'),
    changeItems: (items) => {
      return (dispatch) => {
        dispatch({
          type: 'api_success',
          key: 'links/available',
          items: items
        });
      };
    }
  }
)(Component);
